import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(2),
  padding: (p) => p.spacing(0.5),
};
